module.exports = __webpack_public_path__ + "static/case-5-1cf3670f3e0edd4f43c417f3afdd982f.jpg";